import { useMemo } from 'react';

import { useCurrentTime as useStreamCurrentTime } from '@/scenarios/legacy-player/hooks/useCurrentTime';

import { Time } from '../types/time';

export const useCurrentTime = () => {
    const streamCurrentTime = useStreamCurrentTime();
    /** @see OTT-82541 if need hide preroll timeline */
    const prerollDuration = 0;

    return useMemo(
        () => new Time(streamCurrentTime, prerollDuration ?? 0),
        [prerollDuration, streamCurrentTime]
    );
};
